import React from 'react';
import JsBarcode from 'jsbarcode';
import './ShippingLabels.css';

// UPS Next Day Air Label Component
export const UPSLabel = ({ data }) => {
  const barcodeRef = React.useRef(null);
  const trackingBarcodeRef = React.useRef(null);
  const postalBarcodeRef = React.useRef(null);

  React.useEffect(() => {
    if (barcodeRef.current && data.tracking_number) {
      JsBarcode(barcodeRef.current, data.tracking_number, {
        format: "CODE128",
        width: 2,
        height: 60,
        displayValue: false,
        margin: 0
      });
    }
    
    if (trackingBarcodeRef.current && data.tracking_number) {
      JsBarcode(trackingBarcodeRef.current, data.tracking_number, {
        format: "CODE128",
        width: 1.5,
        height: 40,
        displayValue: false,
        margin: 0
      });
    }

    if (postalBarcodeRef.current && data.consignee_zip) {
      // Generate postal barcode from ZIP
      const postalCode = data.consignee_zip.padStart(5, '0');
      JsBarcode(postalBarcodeRef.current, postalCode, {
        format: "CODE128",
        width: 1,
        height: 25,
        displayValue: false,
        margin: 0
      });
    }
  }, [data]);

  return (
    <div className="ups-label">
      <div className="ups-header">
        <div className="ups-from-section">
          <div className="ups-field-label">FROM NAME</div>
          <div className="ups-field-value">{data.shipper_name}</div>
          <div className="ups-field-label">FROM ADDRESS 1</div>
          <div className="ups-field-value">{data.shipper_address}</div>
          <div className="ups-field-label">FROM CITY, STATE, ZIP</div>
          <div className="ups-field-value">{data.shipper_city}, {data.shipper_state} {data.shipper_zip}</div>
        </div>
        <div className="ups-weight-section">
          <div className="ups-weight-title">WEIGHT LBS {data.weight} OF TOTAL</div>
          <div className="ups-weight-details">
            <div>DWT: {data.weight}</div>
            <div>AH</div>
          </div>
        </div>
      </div>

      <div className="ups-main-section">
        <div className="ups-to-section">
          <div className="ups-ship-to">
            <div className="ups-ship-to-label">SHIP<br />TO:</div>
            <div className="ups-to-details">
              <div className="ups-to-field">{data.consignee_name}</div>
              <div className="ups-to-field">{data.consignee_address}</div>
              <div className="ups-to-field-large">{data.consignee_city}, {data.consignee_state}, {data.consignee_zip}</div>
              <div className="ups-to-field">{data.consignee_country}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="ups-barcode-section">
        <div className="ups-barcode-left">
          <canvas ref={barcodeRef} className="ups-main-barcode" />
        </div>
        <div className="ups-tracking-large">
          {data.tracking_number.substring(0, 8)}
        </div>
      </div>

      <div className="ups-tracking-barcode">
        <canvas ref={trackingBarcodeRef} />
      </div>

      <div className="ups-service-section">
        <div className="ups-service-title">UPS NEXT DAY AIR</div>
        <div className="ups-service-number">1</div>
      </div>

      <div className="ups-tracking-section">
        <div className="ups-tracking-label">TRACKING # {data.tracking_number}</div>
        <canvas ref={postalBarcodeRef} className="ups-postal-barcode" />
      </div>

      <div className="ups-additional-section">
        <div className="ups-additional-text">ADDITIONAL ROUTING INS.</div>
        <div className="ups-additional-text">ADDITIONAL ROUTING INS.</div>
      </div>
    </div>
  );
};

// FedEx Label Component
export const FedExLabel = ({ data }) => {
  const barcodeRef = React.useRef(null);
  const trackingBarcodeRef = React.useRef(null);
  const bottomBarcodeRef = React.useRef(null);

  React.useEffect(() => {
    if (barcodeRef.current && data.tracking_number) {
      JsBarcode(barcodeRef.current, data.tracking_number, {
        format: "CODE128",
        width: 1.5,
        height: 50,
        displayValue: false,
        margin: 0
      });
    }

    if (trackingBarcodeRef.current && data.tracking_number) {
      JsBarcode(trackingBarcodeRef.current, data.tracking_number, {
        format: "CODE128",
        width: 2,
        height: 60,
        displayValue: false,
        margin: 0
      });
    }

    if (bottomBarcodeRef.current && data.consignee_zip) {
      const bottomCode = `9622 0804 3 000 800 0257 0 00 ${data.tracking_number}`;
      JsBarcode(bottomBarcodeRef.current, bottomCode.replace(/\s/g, ''), {
        format: "CODE128",
        width: 1.2,
        height: 40,
        displayValue: false,
        margin: 0
      });
    }
  }, [data]);

  return (
    <div className="fedex-label">
      <div className="fedex-header">
        <div className="fedex-from">
          <div className="fedex-from-label">FROM</div>
          <div className="fedex-from-info">
            <div>{data.shipper_name}</div>
            <div>{data.shipper_address}</div>
            <div>{data.shipper_city}, {data.shipper_state}</div>
            <div>{data.shipper_zip}</div>
            <div>{data.shipper_country}</div>
          </div>
        </div>
        <div className="fedex-ship-info">
          <div className="fedex-ship-date">SHIP DATE {new Date().toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: '2-digit' }).replace(/\//g, '').toUpperCase()}</div>
          <div className="fedex-act-wgt">ACT WGT {data.weight} LB</div>
          <div className="fedex-cod">CAD {Math.random().toString().substring(2, 17)}</div>
          <div className="fedex-bill-sender">BILL SENDER</div>
        </div>
      </div>

      <div className="fedex-to-section">
        <div className="fedex-to-name">{data.consignee_name}</div>
        <div className="fedex-shipment">SHIPMENT</div>
        <div className="fedex-test-label">**TEST LABEL - DO NOT SHIP**</div>
        <div className="fedex-destination">{data.consignee_city} {data.consignee_state} {data.consignee_zip}</div>
        <div className="fedex-phone">(555) 000-0000</div>
      </div>

      <div className="fedex-barcode-section">
        <canvas ref={barcodeRef} className="fedex-main-barcode" />
        <div className="fedex-logo-section">
          <div className="fedex-logo">FedEx</div>
          <div className="fedex-home-delivery">Home Delivery</div>
          <div className="fedex-h-box">H</div>
        </div>
      </div>

      <div className="fedex-tracking-section">
        <div className="fedex-trk-label">TRK# {data.tracking_number}</div>
        <div className="fedex-zip-large">{data.consignee_zip}</div>
      </div>

      <div className="fedex-bottom-barcode">
        <canvas ref={bottomBarcodeRef} />
      </div>
    </div>
  );
};

// DHL Express Easy Label Component
export const DHLLabel = ({ data }) => {
  const topBarcodeRef = React.useRef(null);
  const middleBarcodeRef = React.useRef(null);
  const bottomBarcodeRef = React.useRef(null);

  React.useEffect(() => {
    if (topBarcodeRef.current && data.tracking_number) {
      JsBarcode(topBarcodeRef.current, data.tracking_number, {
        format: "CODE128",
        width: 1.8,
        height: 40,
        displayValue: false,
        margin: 0
      });
    }

    if (middleBarcodeRef.current && data.tracking_number) {
      const waybillNumber = `WAYBILL ${Math.random().toString().substring(2, 13)}`;
      JsBarcode(middleBarcodeRef.current, waybillNumber.replace(/\s/g, ''), {
        format: "CODE128",
        width: 1.5,
        height: 35,
        displayValue: false,
        margin: 0
      });
    }

    if (bottomBarcodeRef.current && data.tracking_number) {
      JsBarcode(bottomBarcodeRef.current, data.tracking_number, {
        format: "CODE128",
        width: 1.5,
        height: 35,
        displayValue: false,
        margin: 0
      });
    }
  }, [data]);

  return (
    <div className="dhl-label">
      <div className="dhl-header">
        <div className="dhl-express-easy">
          <span className="dhl-express">EXPRESS</span>
          <span className="dhl-easy-label">EASY</span>
          <span className="dhl-xep">XEP</span>
          <span className="dhl-logo">DHL</span>
        </div>
      </div>

      <div className="dhl-address-section">
        <div className="dhl-from">
          <div className="dhl-from-label">From:</div>
          <div className="dhl-from-details">
            <div>{data.shipper_name}</div>
            <div>{data.shipper_address}</div>
            <div>{data.shipper_city}</div>
            <div>{data.shipper_state} {data.shipper_zip}</div>
            <div>{data.shipper_country}</div>
          </div>
        </div>
        <div className="dhl-origin">
          <div className="dhl-origin-label">Origin:</div>
          <div className="dhl-origin-code">{data.shipper_state}</div>
          <div className="dhl-contact">Contact: (555) 000-0000</div>
          <div className="dhl-consignee">Consignee:</div>
          <div className="dhl-consignee-id">{Math.random().toString().substring(2, 12)}</div>
        </div>
      </div>

      <div className="dhl-to-section">
        <div className="dhl-to-label">To:</div>
        <div className="dhl-to-name">{data.consignee_name}</div>
        <div className="dhl-to-address">{data.consignee_address}</div>
        <div className="dhl-to-city">{data.consignee_zip} {data.consignee_city} {data.consignee_state}</div>
        <div className="dhl-to-country">{data.consignee_country}</div>
      </div>

      <div className="dhl-service-section">
        <div className="dhl-service-code">US-{data.consignee_state}-{data.consignee_state}</div>
        <div className="dhl-service-details">
          <div className="dhl-city">City</div>
          <div className="dhl-time">Time</div>
          <div className="dhl-pieces">Pieces Weight Price</div>
          <div className="dhl-weight">{data.weight} kg 1/1</div>
        </div>
      </div>

      <div className="dhl-barcode-top">
        <canvas ref={topBarcodeRef} />
        <div className="dhl-contents">Contents Shipment Number {Math.floor(Math.random() * 10)}</div>
      </div>

      <div className="dhl-barcode-middle">
        <div className="dhl-waybill-label">WAYBILL {Math.random().toString().substring(2, 13)}</div>
        <canvas ref={middleBarcodeRef} />
      </div>

      <div className="dhl-barcode-bottom">
        <div className="dhl-shipment-code">(2) JUS{data.consignee_zip}+61000001</div>
        <canvas ref={bottomBarcodeRef} />
        <div className="dhl-shipment-number">({data.tracking_number.substring(0, 1)}) {data.tracking_number}</div>
      </div>
    </div>
  );
}; 